import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable, OnDestroy } from "@angular/core";
import { SensorsCorePool } from "@core_n/asp/SensorsCorePool";
import { UserAlertToken } from "@core_n/common/settings";
import {
  SignalRConnection
} from "ng2-signalr";
import { AppConfig } from "../app.config";
import { BoundingBox } from "../common/boundingBox";
import { MsgBoxService } from "../msg-boxes/msg-box.service";
import { ErrNotificationsHandler } from "./../../../app/asp/ErrNotifications";
import { aspMngr } from "./../asp/AspMngr";
import { ObjectType } from "./../asp/AspObject";
import { NotificationSettings, userSettings } from "./../common/settings";
import { AcousticAzimuth } from "./../models/acoustic.model";
import { CamAzimuth } from "./../models/camera.model";
import { MsgBusFactoryService } from "./msg-bus/msg-bus-factory.service";
import {
  MsgBusConnectConfig,
  MsgBusProvider
} from "./msg-bus/msg-bus-provider";
import { MsgMngrService } from "./msg-mngr.service";

type BoxCallback = (box: BoundingBox) => void;

export enum ServerMessages {
  alerts = "receiveMessage",
  video = "receiveMessageCameraDirection",
  sensor = "receiveMessageSensorData",
}

@Injectable({
  providedIn: "root",
})
export class AlertMsgMngrService implements OnDestroy {
  private callbackMap = new Map<string, BoxCallback>();

  private _connection: SignalRConnection;
  private Address: string = "";
  private token: string = undefined;
  private msgBusProvider: MsgBusProvider;
  constructor(
    private msgBoxSrv: MsgBoxService,
    private msgBusFactoryService: MsgBusFactoryService,
    private http: HttpClient,
    private msgMngrService: MsgMngrService
  ) {
    this.connect();
  }

  setAdress(str: string) {
    this.Address = str;
  }

  getToken(): string {
    return this.token;
  }

  setToken(token: string) {
    this.token = token;
  }

  async authenticate(user: string, pass: string): Promise<any> {
    try {
      const headers = new HttpHeaders({
        "Connect-Type": "application/x-www-form-urlencoded",
      });

      const body = new HttpParams()
        .set("client_id", user)
        .set("client_secret", pass)
        .set("scope", "test")
        .set("grant_type", "client_credentials");

      const resp: any = await this.http
        .post(AppConfig.settings.alertAddress.authAddress, body.toString(), {
          headers,
        })
        .toPromise();
      if (!resp.access_token) {
        this.msgBoxSrv.showErrorMsg(
          "Cannot get Alert Service toke Please Login again..."
        );
        return;
      }
      this.token = resp.access_token;
      sessionStorage.setItem(UserAlertToken, this.token);
    } catch (err) {
      console.error("Cannot get Token From AlertMngr(AWS): ", err);
    }
  }

  connect(): void {
    this.Address = AppConfig.settings.alertAddress.address;
    console.log(`[Alert-Service] url address ${this.Address}`);
    
    var msgBusCfg: MsgBusConnectConfig = {
      url: this.Address,
      hubName: "AcousticHub",
    };
    this.msgBusProvider = this.msgBusFactoryService.create(
      AppConfig.settings.msgBusProvider
    );
    this.msgBusProvider
      .connect(msgBusCfg)
      .then(this.subscribeToListeners)
      .catch((error: any) => {
        console.error(error);
        // disable connect flag
        this.msgBoxSrv.showErrorMsg("ERROR: Sound Service connection failed. ");
      });
  }

  subscribeToListeners = () => {
    console.log(`[Alert-Service] sucscriptions`);
    this.msgBusProvider.subscribe("disconnect", (_) => {
      console.log(`[Alert-Service] disconnect sucscription`);
      this.disconnect();
      this.msgBoxSrv.showWarnMsg("Disconnected From Sound Service...");
    });
    this.toggleMessageConnection(userSettings.notifications);
  };

  ngOnDestroy(): void {
    this.disconnect();
  }

  disconnect(): void {
    this._connection?.stop();
  }

  toggleMessageConnection(notification: Partial<NotificationSettings>): void {
    if (notification.hasOwnProperty("alerts")) {
      if (notification.alerts) {
        this.msgBusProvider.subscribe<any>(
          ServerMessages.alerts,
          this.alertSubscribeCallback
        );
      } else {
        this.msgBusProvider.unsubscribe(ServerMessages.alerts);
      }
    }
    if (notification.hasOwnProperty("videoAzimuth")) {
      if (notification.videoAzimuth) {
        this.msgBusProvider.subscribe<CamAzimuth>(
          ServerMessages.video,
          this.videoSubscribeCallBack
        );
      } else {
        this.msgBusProvider.unsubscribe(ServerMessages.video);
      }
    }
    if (notification.hasOwnProperty("sensorAzimuth")) {
      if (notification.sensorAzimuth) {
        this.msgBusProvider.subscribe<AcousticAzimuth>(
          ServerMessages.sensor,
          this.sensorAzimuthSubscribeCallBack
        );
      } else {
        this.msgBusProvider.unsubscribe(ServerMessages.sensor);
      }
    }
  }

  alertSubscribeCallback = (msgObj: any) => {
    if(AppConfig.settings.env.enableDebugLogging)
      console.log(`[Alert-Service][Alert-msg]`);
    ErrNotificationsHandler.getSelf(this.msgBoxSrv).handleMsg(msgObj);
    if (AppConfig.settings.alertAddress.enableOverlay)
      this.emitMessage(msgObj.StreamName, msgObj.Message);
  };

  videoSubscribeCallBack = (camAzimuth: CamAzimuth) => {
    if(AppConfig.settings.env.enableDebugLogging)
      console.log(`[Alert-Service] azimuth ${camAzimuth?.azimuth} for cam ${camAzimuth?.streamName}.`);
    if (camAzimuth) {
      (aspMngr.getObjectsPool(
        ObjectType.Sensor
      ) as SensorsCorePool).updateVideoSensorAzimuth(camAzimuth);
    }
  };
  sensorAzimuthSubscribeCallBack = (acousticAzimuth: AcousticAzimuth) => {
    if(AppConfig.settings.env.enableDebugLogging)
      console.log(`[Alert-Service] acoustic azimuth ${acousticAzimuth?.azimuth} for sensor ${acousticAzimuth?.sensorId}.`);
    if (acousticAzimuth) {
      this.msgMngrService.invokeHandleMsgByType("MSG_TYPE_SNS_VECTOR", acousticAzimuth);
    }
  };

  subscribeMe(streamName: string, callback: BoxCallback) {
    this.callbackMap.set(streamName, callback);
  }

  unSubscrbeMe(streamName: string) {
    this.callbackMap.delete(streamName);
  }

  emitMessage(streamName: string, msgRaw: string) {
    const callback = this.callbackMap.get(streamName);
    if (!callback) return;
    const box = this.parseBoundingBox(
      msgRaw,
      AppConfig.settings.alertAddress.originResW,
      AppConfig.settings.alertAddress.originResH
    );
    if (!box) return;
    callback(box);
  }

  parseBoundingBox(
    rawMessage: string,
    sourceWidth: number,
    sourceHight: number
  ): BoundingBox | null {
    try {
      const bboxPart = rawMessage.split("bbox=")[1];
      const [p1, p2] = bboxPart.trim().split(" ");

      const [x1, y1] = p1.split(",").map(Number);
      const [x2, y2] = p2.split(",").map(Number);

      const x = Math.min(x1, x2);
      const y = Math.min(y1, y2);
      const width = Math.abs(x2 - x1);
      const height = Math.abs(y2 - y1);

      return new BoundingBox(x, y, width, height, sourceWidth, sourceHight);
    } catch (err) {
      console.log("Failed to parse the bbox... ", err);
      return null;
    }
  }
}
